/**
 * A `host` that is a list row is drawn in the row's box (the card's width,
 * the row's height with its padding), as every row is, while the engine
 * measured and placed its content in the row's content frame inside it.
 * The content element goes back into that frame, as a text row's text is
 * padded into its own (layoutDom.ts), so DOM content that fills its box
 * (`sizing: "fill"`, `height: 100%`) fills what it was measured for and
 * not the row's padding too.
 */

import type { Rect } from './layout';

export interface HostContentInset {
  left: number;
  top: number;
  width: number;
  height: number;
}

/** Where the content sits inside the element's box; null when the box is the frame (nothing to set). */
export function hostContentInset(box: Rect, frame: Rect): HostContentInset | null {
  const left = frame.x - box.x;
  const top = frame.y - box.y;
  if (left === 0 && top === 0 && frame.width === box.width && frame.height === box.height) return null;
  return { left, top, width: frame.width, height: frame.height };
}
